import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import * as countries from 'i18n-iso-countries';
import frLocale from 'i18n-iso-countries/langs/fr.json';
import { Router } from '@angular/router';

@Component({
  selector: 'app-control',
  templateUrl: './control.component.html',
  styleUrls: ['./control.component.scss']
})
export class ControlComponent implements OnInit {

  dataStat = [];
  dataStatUser = [];
  dataStatUserClicked = [];
  displayedColumns: string[] = ['libelle', 'chiffre'];
  secteur = "";
  nbcollaborators = 0;
  userEmail = '';
  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  contacts = [];
  contactsclick = [];
  todaycontacts = [];
  todaycontactsclick = [];
  yesterdaycontacts = [];
  yesterdaycontactsclick = [];
  beforeyesterdaycontacts = [];
  beforeyesterdaycontactsclick = [];
  weekcontacts = [];
  weekcontactsclick = [];
  monthcontacts = [];
  monthcontactsclick = [];

  //start
  activeTab: 'all' | 'missions' | 'taches' | 'envoyes' | 'recus' = 'all';
  tooltipVisible = false;
  tooltipProjetIndex: number = null;
  actif_project = 0;
  loading: boolean = true;
  
  showStatutMenu = false;

  activeSubMenu: string | null = null;

  selectedStatus: string = null;

  projets: any[] = [
    {
      etat: 'bloque',
      nom: 'Voirie centre-ville',
      finProjet: '30/09/2026',
      tempsRestant: 119,
      missions: 8,
      missionsEnRetard: 6,
      tachesEnRetard: 14,
      messagesEnvoyesNonRepondus: 14,
      messagesRecusNonTraites: 9
    },
    {
      etat: 'risque',
      nom: 'École Alexandre Dumas',
      finProjet: '31/12/2026',
      tempsRestant: 211,
      missions: 6,
      missionsEnRetard: 3,
      tachesEnRetard: 8,
      messagesEnvoyesNonRepondus: 8,
      messagesRecusNonTraites: 4
    },
    {
      etat: 'risque',
      nom: 'Gymnase Jean Jaurès',
      finProjet: '20/10/2026',
      tempsRestant: 139,
      missions: 7,
      missionsEnRetard: 4,
      tachesEnRetard: 11,
      messagesEnvoyesNonRepondus: 11,
      messagesRecusNonTraites: 5
    },
    {
      etat: 'bonne-voie',
      nom: 'Réhabilitation Mairie',
      finProjet: '15/11/2026',
      tempsRestant: 165,
      missions: 5,
      missionsEnRetard: 0,
      tachesEnRetard: 2,
      messagesEnvoyesNonRepondus: 6,
      messagesRecusNonTraites: 2
    },
    {
      etat: 'bonne-voie',
      nom: 'Crèche municipale',
      finProjet: '15/11/2026',
      tempsRestant: 165,
      missions: 5,
      missionsEnRetard: 0,
      tachesEnRetard: 0,
      messagesEnvoyesNonRepondus: 3,
      messagesRecusNonTraites: 1
    }
  ];

  get projetsActifs(): number {
    return this.projets.length;
  }

  get projetsBloques(): number {
    return this.projets.filter(p => p.etat === 'bloque').length;
  }

  get projetsARisque(): number {
    return this.projets.filter(p => p.etat === 'risque').length;
  }

  get projetsBonneVoie(): number {
    return this.projets.filter(p => p.etat === 'bonne-voie').length;
  }

  toggleStatutMenu(): void {
    this.showStatutMenu = !this.showStatutMenu;
    if (!this.showStatutMenu) {
      this.activeSubMenu = null;
    }
  }

  openSubMenu(type: string, event: Event): void {
    event.stopPropagation();
    this.activeSubMenu = this.activeSubMenu === type ? null : type;
  }

  chooseStatus(value: string): void {
    this.selectedStatus = value;
    this.showStatutMenu = false;
    this.activeSubMenu = null;
    // ici tu peux émettre un event vers le parent, appeler un sujet, etc.
    console.log('Statut choisi :', value);
  }

  // ferme le menu si on clique en dehors
  closeAll(): void {
    console.log("cliqued")
    this.showStatutMenu = false;
    this.activeSubMenu = null;
  }

  projetsFiltres() {
    this.projets = [];
    if (this.activeTab === 'all') {
      this.authService.getPilotageData('all').subscribe(data => {
          this.projets = data['hydra:member'].map(p => ({
            id:                          p.id,
            nom:                         p.libelle,
            finProjet:                   (p.deadline ? p.deadline : '—'),
            tempsRestant:                (p.daysRemaining ? p.daysRemaining : '—'),
            missions:                    p.totalMissions,
            //missionsEnRetard:            p.lateMissions,
            tachesEnRetard:              p.lateTasks,
            messagesEnvoyesNonRepondus:  p.sentUnanswered,
            messagesRecusNonTraites:     p.receivedUnhandled,
            isMember:     p.isMember
          }))
          this.loading = false;
      });
      //return this.projets.filter(p => p.tachesEnRetard > 0);
    } else if (this.activeTab === 'missions') {
      this.authService.getPilotageData('lateMissions').subscribe(data => {
          this.projets = data['hydra:member'].map(p => ({
            id:                          p.id,
            nom:                         p.libelle,
            finProjet:                   (p.deadline ? p.deadline : '—'),
            tempsRestant:                (p.daysRemaining ? p.daysRemaining : '—'),
            missions:                    p.totalMissions,
            //missionsEnRetard:            p.lateMissions,
            tachesEnRetard:              p.lateTasks,
            messagesEnvoyesNonRepondus:  p.sentUnanswered,
            messagesRecusNonTraites:     p.receivedUnhandled,
            isMember:     p.isMember
          }))
          this.loading = false;
      });
      //return this.projets.filter(p => p.tachesEnRetard > 0);
    } else if (this.activeTab === 'taches') {
      this.authService.getPilotageData('lateTasks').subscribe(data => {
          this.projets = data['hydra:member'].map(p => ({
            id:                          p.id,
            nom:                         p.libelle,
            finProjet:                   (p.deadline ? p.deadline : '—'),
            tempsRestant:                (p.daysRemaining ? p.daysRemaining : '—'),
            missions:                    p.totalMissions,
            //missionsEnRetard:            p.lateMissions,
            tachesEnRetard:              p.lateTasks,
            messagesEnvoyesNonRepondus:  p.sentUnanswered,
            messagesRecusNonTraites:     p.receivedUnhandled,
            isMember:     p.isMember
          }))
          this.loading = false;
      });
    } else if (this.activeTab === 'envoyes') {
      this.authService.getPilotageData('sentUnanswered').subscribe(data => {
          this.projets = data['hydra:member'].map(p => ({
            id:                          p.id,
            nom:                         p.libelle,
            finProjet:                   (p.deadline ? p.deadline : '—'),
            tempsRestant:                (p.daysRemaining ? p.daysRemaining : '—'),
            missions:                    p.totalMissions,
            //missionsEnRetard:            p.lateMissions,
            tachesEnRetard:              p.lateTasks,
            messagesEnvoyesNonRepondus:  p.sentUnanswered,
            messagesRecusNonTraites:     p.receivedUnhandled,
            isMember:     p.isMember
          }))
          this.loading = false;
      });
    } else {
      this.authService.getPilotageData('receivedUnhandled').subscribe(data => {
          this.projets = data['hydra:member'].map(p => ({
            id:                          p.id,
            nom:                         p.libelle,
            finProjet:                   (p.deadline ? p.deadline : '—'),
            tempsRestant:                (p.daysRemaining ? p.daysRemaining : '—'),
            missions:                    p.totalMissions,
            //missionsEnRetard:            p.lateMissions,
            tachesEnRetard:              p.lateTasks,
            messagesEnvoyesNonRepondus:  p.sentUnanswered,
            messagesRecusNonTraites:     p.receivedUnhandled,
            isMember:     p.isMember
          }))
          this.loading = false;
      });
    }
    //return this.projets;
  }

  goToProject(project){
    //if(project.isMember){
      this.router.navigate(['/project/'+project.id]);
    //} else alert("Vous êtes pas membre dens cette mission.")
  }

  goToProjectMissions(project){
    //if(project.isMember){
      if(this.activeTab === 'missions') this.router.navigate(['/project/'+project.id+'/missions']);
    //} else alert("Vous êtes pas membre dens cette mission.")
  }

  goToProjectTasks(project){
    //if(project.isMember){
      if(this.activeTab === 'taches') this.router.navigate(['/project/'+project.id+'/tasks']);
    //} else alert("Vous êtes pas membre dens cette mission.")
  }

  goToProjectSent(project){
    //if(project.isMember){
      if(this.activeTab === 'envoyes') this.router.navigate(['/project/'+project.id+'/sent']);
    //} else alert("Vous êtes pas membre dens cette mission.")
  }

  goToProjectReceived(project){
    //if(project.isMember){
      if(this.activeTab === 'recus') this.router.navigate(['/project/'+project.id+'/received']);
    //} else alert("Vous êtes pas membre dens cette mission.")
  }

  /*getEtat(p: any) {
    if (p.lateMissions > 0 || p.lateTasks >= 5) return 'bloque';
    if (p.lateMissions > 0 || p.lateTasks > 0) return 'risque';
    return 'bonne-voie';
  }*/

  setTab(tab: 'all' | 'missions' | 'taches' | 'envoyes' | 'recus') {
    if(tab === 'missions') {
    this.activeTab = tab;
      return;
    }
    this.loading = true;
    this.activeTab = tab;
    this.projetsFiltres();
  }

  showTooltip(index: number) {
    this.tooltipProjetIndex = index;
    this.tooltipVisible = true;
  }

  hideTooltip() {
    this.tooltipVisible = false;
    this.tooltipProjetIndex = null;
  }

  getEtatIcon(etat: string): string {
    return etat;
  }

  constructor(public authService: AuthService, private router: Router) { }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.userEmail = this.currentUser['email'];
    this.secteur = localStorage.getItem('secteur');
  	this.getStatistique();
    this.getActifProjects();
    this.projetsFiltres();
  }

  onTabClick(tab: string) {
    //this.authService.getPilotageData(tab).subscribe(data => this.tableData = data);
  }

  getCountry(country){
    countries.registerLocale(frLocale);

    const countryName = countries.getName(country, 'fr');
    return countryName;
  }

  getStatistiqueUser(contact, j){
    if(this.monthcontacts.length > 0){
      for (let i = 0; i < this.monthcontacts.length; i++) {
        if(i == j){
          this.monthcontactsclick[i] = true;
       } else {
          this.monthcontactsclick[i] = false;
        }
      }
    }
    if(this.contacts.length > 0){
      for (let i = 0; i < this.contacts.length; i++) {
        if(i == j){
          this.contactsclick[i] = true;
       } else {
          this.contactsclick[i] = false;
        }
      }
    }
    if(this.weekcontacts.length > 0){
      for (let i = 0; i < this.weekcontacts.length; i++) {
        if(i == j){
          this.weekcontactsclick[i] = true;
       } else {
          this.weekcontactsclick[i] = false;
        }
      }
    }
    if(this.beforeyesterdaycontacts.length > 0){
      for (let i = 0; i < this.beforeyesterdaycontacts.length; i++) {
        if(i == j){
          this.beforeyesterdaycontactsclick[i] = true;
       } else {
          this.beforeyesterdaycontactsclick[i] = false;
        }
      }
    }
    if(this.yesterdaycontacts.length > 0){
      for (let i = 0; i < this.yesterdaycontacts.length; i++) {
        if(i == j){
          this.yesterdaycontactsclick[i] = true;
       } else {
          this.yesterdaycontactsclick[i] = false;
        }
      }
    }
    if(this.todaycontacts.length > 0){
      for (let i = 0; i < this.todaycontacts.length; i++) {
        if(i == j){
          this.todaycontactsclick[i] = true;
       } else {
          this.todaycontactsclick[i] = false;
        }
      }
    }
    this.authService.getStatUser(contact.id).subscribe(  
    (success) => {
     
      var dataArray = success['hydra:member'];
     
      this.dataStatUser = [{
        libelle: "SuperCanaux",
        chiffre: dataArray.totalProjectUser
      },
      {
        libelle: "Thèmes",
        chiffre: dataArray.totalTagUser
      },
      {
        libelle: "Nombre de faces",
        chiffre: dataArray.totalFaceUser
      },
      {
        libelle: "Nombre de messages",
        chiffre: dataArray.totalMessageUser
      },
      {
        libelle: "Nombre de documents",
        chiffre: dataArray.totalFileUser
      },
      {
        libelle: "Poid des documents",
        chiffre: dataArray.totalSize
      },
    ]; 
       
    },
    (error) => {
      alert('Erreur ! : ' + error)
    });
  }

  getSubject(subject){
    if(subject === "Thématique d'échange"){
      return "Thèmatiques d'échange";
      } else return subject+"s";
  }

  getActifProjects(){
    this.authService.getProjectsIds().subscribe(res => {
      var resultat = res['hydra:member'];
      this.actif_project = resultat.filter(item => item.isArchived == false).length;
    })
  }

  getStatistique(){
    this.authService.getStat().subscribe(  
    (success) => {
     
      var dataArray = success['hydra:member'];
      this.nbcollaborators = dataArray.totaUserCompany;
      this.dataStat = [{
        libelle: "Nombre d'inscrits",
        chiffre: dataArray.totalUser
      },
      {
        libelle: "SuperCanaux",
        chiffre: dataArray.totalProject
      },
      {
        libelle: "Thèmes",
        chiffre: dataArray.totalTag
      },
      {
        libelle: "Nombre de faces",
        chiffre: dataArray.totalFace
      },
      {
        libelle: "Nombre de messages",
        chiffre: dataArray.totalMessage
      },
      {
        libelle: "Nombre de documents",
        chiffre: dataArray.totalFile
      },
      {
        libelle: "Poid des documents",
        chiffre: dataArray.totalSize
      },
      {
        libelle: "24 heures",
        chiffre: dataArray.dayUser
      },
      {
        libelle: "Dernière semaine",
        chiffre: dataArray.weekUser
      },
      {
        libelle: "Ce mois ci",
        chiffre: dataArray.currentMonthUser
      },
      {
        libelle: "Dernier mois",
        chiffre: dataArray.lastMonthUser
      },
      {
        libelle: "Dernièr 30 jours",
        chiffre: dataArray.last30daysUser
      },
      {
        libelle: "Tous les inscrits",
        chiffre: dataArray.allUsers
      },
      {
        libelle: "Aujourd'hui",
        chiffre: dataArray.todayUser
      },
      {
        libelle: "Hier",
        chiffre: dataArray.yesterdayUser
      },
      {
        libelle: "Avant hier",
        chiffre: dataArray.beforeYesterdayUser
      },
    ]; 
       
    },
    (error) => {
      alert('Erreur ! : ' + error)
    });
  }


  loadContact(url?: string){
    url = url ? url : undefined;
    this.todaycontacts = [];
    this.yesterdaycontacts = [];
    this.beforeyesterdaycontacts = [];
    this.weekcontacts = [];
    this.monthcontacts = [];
    this.authService.getAllContacts(url).subscribe(res => {
      	this.contacts = this.contacts.concat(res['hydra:member']);
        for (let i = 0; i < this.contactsclick.length; i++) {
          this.contactsclick[i] = false;
        }
    }); 
  }

  loadTodayContact(url?: string){
    url = url ? url : undefined;
    this.contacts = [];
    this.yesterdaycontacts = [];
    this.beforeyesterdaycontacts = [];
    this.weekcontacts = [];
    this.monthcontacts = [];
    this.authService.getTodayContacts(url).subscribe(res => {
      	this.todaycontacts = this.todaycontacts.concat(res['hydra:member']);
        for (let i = 0; i < this.todaycontactsclick.length; i++) {
          this.todaycontactsclick[i] = false;
         }
    }); 
  }

  loadYesterdayContact(url?: string){
    url = url ? url : undefined;
    this.contacts = [];
    this.todaycontacts = [];
    this.beforeyesterdaycontacts = [];
    this.weekcontacts = [];
    this.monthcontacts = [];
    this.authService.getYesterdayContacts(url).subscribe(res => {
      	this.yesterdaycontacts = this.yesterdaycontacts.concat(res['hydra:member']);
        for (let i = 0; i < this.yesterdaycontactsclick.length; i++) {
          this.yesterdaycontactsclick[i] = false;
         }
    }); 
  }

  loadBeforeYesterdayContact(url?: string){
    url = url ? url : undefined;
    this.contacts = [];
    this.todaycontacts = [];
    this.yesterdaycontacts = [];
    this.weekcontacts = [];
    this.monthcontacts = [];
    this.authService.getBeforeYesterdayContacts(url).subscribe(res => {
      	this.beforeyesterdaycontacts = this.beforeyesterdaycontacts.concat(res['hydra:member']);
        for (let i = 0; i < this.beforeyesterdaycontactsclick.length; i++) {
          this.beforeyesterdaycontactsclick[i] = false;
         }
    }); 
  }

  loadWeekContact(url?: string){
    url = url ? url : undefined;
    this.contacts = [];
    this.todaycontacts = [];
    this.yesterdaycontacts = [];
    this.beforeyesterdaycontacts = [];
    this.monthcontacts = [];
    this.authService.getWeekContacts(url).subscribe(res => {
        this.weekcontacts = [];
      	this.weekcontacts = this.weekcontacts.concat(res['hydra:member']);
        for (let i = 0; i < this.weekcontactsclick.length; i++) {
          this.weekcontactsclick[i] = false;
         }
    }); 
  }

  loadMonthContact(url?: string){
    url = url ? url : undefined;
    this.contacts = [];
    this.todaycontacts = [];
    this.yesterdaycontacts = [];
    this.beforeyesterdaycontacts = [];
    this.weekcontacts = [];
    this.authService.getMonthContacts(url).subscribe(res => {
      	this.monthcontacts = this.monthcontacts.concat(res['hydra:member']);
        for (var i = 0; i < this.monthcontacts.length; i++) {
          this.monthcontactsclick[i] = false;
        }
    }); 
  }

}	
